import { Component, OnInit, ViewChild } from "@angular/core";
import { EvaluatorService } from "src/app/core/services/evaluator.service";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { Router } from "@angular/router";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-evaluator-application-list",
  templateUrl: "./evaluator-application-list.component.html",
  styleUrls: ["./evaluator-application-list.component.scss"],
})
export class EvaluatorPortalComponent implements OnInit {
  isLoading: boolean = false;
  applications;
  filteredApplications;
  paginatedData: any[] = [];
  pageSize = 10;  
  pageIndex = 0;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  evaluatorDetails;
  searchControl = new FormControl();
  workPermitTypeControl = new FormControl();
  dateControl = new FormControl();
  maxDate: Date;

  constructor(
    private evaluatorService: EvaluatorService,
    private router: Router
  ) {
    this.searchControl.valueChanges.subscribe((value) => {
      this.applyFilters();
    });

    this.workPermitTypeControl.valueChanges.subscribe(() => {
      this.applyFilters();
    });

    this.dateControl.valueChanges.subscribe(() => {
      this.applyFilters();
    });
  }

  applyFilters() {
    const searchValue = this.searchControl.value
      ? this.searchControl.value.toLowerCase()
      : "";
    const selectedType = this.workPermitTypeControl.value;
    const selectedDate = this.dateControl.value;

    this.filteredApplications = this.applications.filter((application) => {
      const matchesSearch =
        !searchValue ||
        application.apn.toLowerCase().includes(searchValue) ||
        application.applicantName?.toLowerCase().includes(searchValue);

      const matchesType = selectedType
        ? application.workingPermitType.toString() === selectedType
        : true;

      const matchesDate = selectedDate
        ? new Date(application.createdDate).toDateString() ===
          new Date(selectedDate).toDateString()
        : true;

      return matchesSearch && matchesType && matchesDate;
    });

    this.paginateData();
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.evaluatorDetails = JSON.parse(
      localStorage.getItem("evaluator_details")
    );
    this.evaluatorService.getApplications().subscribe((applications) => {
      this.applications = applications.data;
      this.filteredApplications = this.applications;
      this.maxDate = new Date();

      this.paginateData();

      this.isLoading = false;
    });
  }
  getOccupation(workingPermitType: number, occupation: string): string {
    if (workingPermitType === 3 || workingPermitType === 4) {
      return 'Entertainer';
    }
    return occupation || 'Not specified';
  }

  paginateData() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = this.filteredApplications.slice(startIndex, endIndex);
  }

  resetDateFilter() {
    this.dateControl.setValue(null);
    this.applyFilters();
  }

  handlePageEvent(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.paginateData();
  }

  viewApplication(application) {
    const url = `/evaluator/dashboard/application/${application.id}`;
    window.location.href = url; 


    // this.router.navigate(["/evaluator/dashboard/application", application.id]);
  }

  approveAll() {
    this.isLoading = true;
    this.evaluatorService.cmoApproveAll().subscribe((res) => {
      this.isLoading = false;
    });
  }
}
